// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"619b30d2","366":"afe52c3d","503":"d30d6d4b","846":"131980f5"}[chunkId] + ".chunk.js";
};